import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {authLoader} from '../../loader';
import {
  ROUTE_SECONDARY_BRAND_ALLOCATION_ZSM_APPROVAL,
} from '@app/navigations/RoutePathConstant';

const SecondaryBrandAllocationApprovalZSM = lazy(() =>
  import('../../../screens/SecondaryBrandAllocationApprovalZSM')
    .then(module => ({default: module.SecondaryBrandAllocationApprovalZSM})));

const SecondaryBrandAllocationApprovalZSMNavigation = [
  {
    path: ROUTE_SECONDARY_BRAND_ALLOCATION_ZSM_APPROVAL,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <SecondaryBrandAllocationApprovalZSM />
      </Suspense>
    ),
  },
];

export default SecondaryBrandAllocationApprovalZSMNavigation;
